import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { api } from "../lib/api";
import { Clapperboard, Clock, Sparkles, ArrowRight } from "lucide-react";
import { toast } from "sonner";

export const VlogTemplates = ({ open, onOpenChange, onPickTemplate }) => {
  const [tpls, setTpls] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    api.get("/templates").then((r) => setTpls(r.data.templates || [])).catch(() => {}).finally(() => setLoading(false));
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-sm max-w-4xl border-black/10" data-testid="vlog-templates-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl tracking-tight flex items-center gap-2">
            <Clapperboard className="w-5 h-5 text-[#E60000]" /> Vlog templates
          </DialogTitle>
          <DialogDescription className="text-xs uppercase tracking-[0.2em] text-[#E60000] font-bold">
            Quick-start edits · Best Ever Food Review style + more
          </DialogDescription>
        </DialogHeader>

        {loading ? (
          <div className="py-12 text-center text-sm text-black/40">Loading templates…</div>
        ) : (
          <div className="grid md:grid-cols-2 gap-4" data-testid="templates-grid">
            {tpls.map((t) => (
              <div key={t.id} className="border border-black/10 hover:border-black transition-colors group" data-testid={`template-${t.id}`}>
                <div
                  className="aspect-video bg-cover bg-center relative"
                  style={{ backgroundImage: `url(${t.thumbnail})` }}
                >
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
                  <div className="absolute bottom-3 left-3 right-3 text-white">
                    <div className="font-mono text-[10px] tracking-wider opacity-80">
                      {t.duration}s · {t.scenes.length} scenes
                    </div>
                    <div className="font-heading font-black text-lg tracking-tight">{t.name}</div>
                  </div>
                  <span
                    className="absolute top-3 left-3 font-mono text-[10px] tracking-wider px-1.5 py-0.5 text-white font-bold"
                    style={{ background: t.color }}
                  >
                    TEMPLATE
                  </span>
                </div>
                <div className="p-4">
                  <p className="text-sm text-black/60">{t.vibe}</p>
                  <div className="mt-3 flex flex-wrap gap-1.5">
                    {t.scenes.map((s, i) => (
                      <span key={i} className="text-[10px] uppercase tracking-wider px-2 py-0.5 border border-black/15">
                        {i + 1}. {s}
                      </span>
                    ))}
                  </div>
                  <div className="mt-4 flex items-center justify-between">
                    <span className="text-xs text-black/50 flex items-center gap-1.5">
                      <Clock className="w-3.5 h-3.5" /> {t.duration}s edit
                    </span>
                    <Button
                      onClick={() => { onPickTemplate?.(t); toast.success(`"${t.name}" loaded — apply to your media`); onOpenChange(false); }}
                      className="rounded-sm bg-[#E60000] hover:bg-[#CC0000] text-white"
                      data-testid={`use-template-${t.id}`}
                    >
                      <Sparkles className="w-3.5 h-3.5 mr-2" /> Use template
                      <ArrowRight className="w-3.5 h-3.5 ml-2" />
                    </Button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
